module.exports = {"columns":[{"Header":"","accessor":"view","sortable":false,"filterable":false},{"Header":"Complete Date","accessor":"completeDate"},{"Header":"Settlement #","accessor":"tripNumber"},{"Header":"Invoice Count","accessor":"invoiceCount"},{"Header":"Total Disbursement","accessor":"totalDisbursement"},{"Header":"Total Invoice Amount","accessor":"totalRevenue"},{"Header":"Total Factoring Fees","accessor":"totalFactoringFees"}]}


//////////////////
// WEBPACK FOOTER
// ./src/tables/columns/settlements.json
// module id = 1982
// module chunks = 3